import { Service } from '@roc/feature-app-core';

const url = {
  DOCUMENTS: '/api/v1/document/docLibrary/v3/documents',
};

export class DocumentLibraryV3Service extends Service {
  getDocumentContent(documentId: string | number) {
    return this.get(`${url.DOCUMENTS}/${documentId}/content`);
  }
}
